module.exports = __webpack_public_path__ + "static/sport/swiper-2.5011676.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/swiper-2.png
// module id = gZYV
// module chunks = 0